export const STUDIO_LOGO = "/lime-logo.png";

export const WHATSAPP_NUMBER = "918055316262"; // +91 80553 16262
export const PHONE_DISPLAY = "+91 80553 16262";
export const STUDIO_ADDRESS =
  "LIME Studios, 605, Montvert Velocity, Baner–Pashan Link Road, Pashan, Pune, Maharashtra 411021";

export const HERO_IMAGE = "/img/hero-1.webp";
export const HERO_IMAGES = [
  "/img/hero-1.webp",
  "/img/hero-2.webp",
];
export const PODCAST_IMAGE = "/img/podcast.webp";
export const PHOTO_IMAGE = "/img/photoshoot.webp";
export const VIDEO_IMAGE = "/img/video.webp";

export const STUDIO_SETS = [
  {
    id: "photoshoot",
    title: "Photoshoot",
    blurb:
      "Sound-treated studio with seamless paper backdrops, fabric drops and pro continuous lighting.",
    image: PHOTO_IMAGE,
    tags: ["Seamless backdrops", "Continuous lights", "Makeup console"],
  },
  {
    id: "video",
    title: "Video Shoot",
    blurb:
      "Multicam-ready set with Sony 4K kits, lapel & boom mics and a teleprompter on demand.",
    image: VIDEO_IMAGE,
    tags: ["Sony 4K", "Teleprompter", "Pro videographer"],
  },
  {
    id: "podcast",
    title: "Podcast",
    blurb:
      "Acoustically treated podcast set with Rode mics, Zoom recorder and warm ambient lighting.",
    image: PODCAST_IMAGE,
    tags: ["Rode PodMic", "Zoom H6", "Custom logo set"],
  },
];

export const FEATURES = [
  { icon: "Mic", label: "Podcast Studio for Rent" },
  { icon: "Armchair", label: "Studio Props & Decor" },
  { icon: "Sparkles", label: "Makeup Console" },
  { icon: "Clock", label: "24 × 7 Availability" },
  { icon: "Wind", label: "Air-Conditioned Studio" },
  { icon: "Car", label: "Dedicated Parking" },
  { icon: "Camera", label: "Professional Equipment" },
  { icon: "Film", label: "End-to-End Production" },
  { icon: "Users", label: "Professional Guidance" },
];

export const TIME_SLOTS = Array.from({ length: 24 }, (_, i) => `${String(i).padStart(2, "0")}:00`);

// Display helper: "07:00" → "7:00 AM", "18:00" → "6:00 PM"
export const formatTime12h = (hhmm) => {
  if (!hhmm || typeof hhmm !== "string" || !hhmm.includes(":")) return hhmm || "";
  const [h, m] = hhmm.split(":").map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return hhmm;
  const period = h >= 12 ? "PM" : "AM";
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${h12}:${String(m).padStart(2, "0")} ${period}`;
};

// Curated dark-studio gallery items — supports both images and YouTube videos (incl. Shorts)
export const GALLERY_IMAGES = [
  {
    type: "video",
    youtubeId: "ty_IA_cQgiU",
    aspect: "16/9",
    src: "https://img.youtube.com/vi/ty_IA_cQgiU/maxresdefault.jpg",
    category: "Podcast",
    caption: "Ant in Elephant's Trunk",
    span: "wide",
  },
  {
    type: "video",
    youtubeId: "ooopgmmmYmI",
    aspect: "16/9",
    src: "https://img.youtube.com/vi/ooopgmmmYmI/maxresdefault.jpg",
    category: "Podcast",
    caption: "Soulsome With Sarika",
    span: "wide",
  },
  {
    type: "video",
    youtubeId: "cX4HnNukf8g",
    aspect: "9/16",
    src: "https://img.youtube.com/vi/cX4HnNukf8g/maxresdefault.jpg",
    category: "Behind the scenes",
    caption: "#BehindTheScenes",
    span: "tall",
  },
  {
    type: "video",
    youtubeId: "mCUWayMqVQI",
    aspect: "9/16",
    src: "https://img.youtube.com/vi/mCUWayMqVQI/maxresdefault.jpg",
    category: "Behind the scenes",
    caption: "#BehindTheScenes",
    span: "tall",
  },
  {
    type: "video",
    youtubeId: "cNo48J0pUL8",
    aspect: "9/16",
    src: "https://img.youtube.com/vi/cNo48J0pUL8/maxresdefault.jpg",
    category: "Behind the scenes",
    caption: "#BehindTheScenes",
    span: "tall",
  },
  {
    type: "video",
    youtubeId: "SllRgbPFQXI",
    aspect: "9/16",
    src: "https://img.youtube.com/vi/SllRgbPFQXI/maxresdefault.jpg",
    category: "Behind the scenes",
    caption: "#BehindTheScenes",
    span: "tall",
  },
  {
    type: "video",
    youtubeId: "sTlpmsywW88",
    aspect: "9/16",
    src: "https://img.youtube.com/vi/sTlpmsywW88/maxresdefault.jpg",
    category: "Behind the scenes",
    caption: "#BehindTheScenes",
    span: "tall",
  },
  {
    type: "video",
    youtubeId: "Y3DTHJC6AKA",
    aspect: "9/16",
    src: "https://img.youtube.com/vi/Y3DTHJC6AKA/maxresdefault.jpg",
    category: "Video",
    caption: "A3 Career",
    span: "tall",
  },
  {
    type: "video",
    youtubeId: "8LXWKPQg89A",
    aspect: "9/16",
    src: "https://img.youtube.com/vi/8LXWKPQg89A/maxresdefault.jpg",
    category: "Video",
    caption: "Kneesy",
    span: "tall",
  },
  {
    type: "video",
    youtubeId: "IeVAus7m0j8",
    aspect: "9/16",
    src: "https://img.youtube.com/vi/IeVAus7m0j8/maxresdefault.jpg",
    category: "Video",
    caption: "Inner Child Awakening",
    span: "tall",
  },
  {
    src: "/img/gal-tanvi.webp",
    category: "Photoshoot",
    caption: "Editorial portrait — Tanvi",
    span: "tall",
  },
  {
    src: "/img/gal-product.webp",
    category: "Photoshoot",
    caption: "Product photography",
    span: "normal",
  },
  {
    src: "/img/gal-brand.webp",
    category: "Photoshoot",
    caption: "Brand campaign",
    span: "normal",
  },
  {
    src: "/img/gal-headshot.webp",
    category: "Photoshoot",
    caption: "Corporate headshot",
    span: "normal",
  },
  {
    src: "/img/gal-exec.webp",
    category: "Photoshoot",
    caption: "Executive portrait",
    span: "normal",
  },
];

// Studio Sets — physical sets / spaces gallery
export const STUDIO_SETS_GALLERY = {
  "Podcast Sets": {
    description:
      "Colour-graded podcast sets with pro mic and mood lighting — pick your palette.",
    images: [
      { src: "/img/set-1.webp", caption: "Red set · purple mood" },
      { src: "/img/set-2.webp", caption: "Red set · warm mood" },
      { src: "/img/set-3.webp", caption: "Blue set · magenta mood" },
      { src: "/img/set-4.webp", caption: "Blue set · sunset mood" },
      { src: "/img/set-5.webp", caption: "Green set · sunset mood" },
      { src: "/img/set-6.webp", caption: "Beige set · magenta mood" },
      { src: "/img/set-7.webp", caption: "Red set · bookshelf" },
      { src: "/img/set-8.webp", caption: "Red set · sunset glow" },
      { src: "/img/set-9.webp", caption: "Green set · bamboo backdrop" },
    ],
  },
};

export const EQUIPMENT_STRIP = [
  { img: "/img/eq-1.webp",  label: "Sony Full Frame 4K Cameras" },
  { img: "/img/eq-2.webp",  label: "DJI Ronin M & DJI Ronin RS4 mini" },
  { img: "/img/eq-3.webp",  label: "Godox LITEMONS LA600R/Bi × 2" },
  { img: "/img/eq-4.webp",  label: "Zoom H6 Recorder" },
  { img: "/img/eq-5.webp",  label: "Rode Podmic × 2" },
  { img: "/img/eq-6.webp",  label: "Sand Bags" },
  { img: "/img/eq-7.webp",  label: "Light Modifiers × 4" },
  { img: "/img/eq-8.webp",  label: "Teleprompter" },
  { img: "/img/eq-9.webp",  label: "Professional Tripods" },
  { img: "/img/eq-10.webp", label: "Hollyland LARK MAX Wireless Mic" },
  { img: "/img/eq-11.webp", label: "Godox VL200 Video Light × 2" },
];

// Replace with your YouTube/Vimeo showreel ID anytime
export const SHOWREEL = {
  poster:
    "https://img.youtube.com/vi/vFTseY_xCc4/maxresdefault.jpg",
  embed: "https://www.youtube.com/embed/vFTseY_xCc4?autoplay=1&rel=0",
  title: "LIME Studios · 2026 Showreel",
};
